<template>
    <div class="facebook-callback">
        <div class="text-center p-10">
            <p>{{ message }}</p>
        </div>
    </div>
</template>

<script>
// Liste blanche des suffixes/hôtes autorisés à recevoir le token.
// Protège contre un `state` forgé pointant vers un domaine attaquant.
const ALLOWED_HOST_SUFFIXES = ['.studioconnect.fr'];
const ALLOWED_EXACT_HOSTS = ['studioconnect.fr', 'localhost'];

function isAllowedTenantOrigin(origin) {
    try {
        const url = new URL(origin);
        if (ALLOWED_EXACT_HOSTS.includes(url.hostname)) return true;
        return ALLOWED_HOST_SUFFIXES.some(suffix => url.hostname.endsWith(suffix));
    } catch (e) {
        return false;
    }
}

export default {
    name: 'FacebookCallback',
    data() {
        return {
            message: 'Connexion en cours...'
        };
    },
    mounted() {
        this.handleCallback();
    },
    methods: {
        handleCallback() {
            const hashParams = new URLSearchParams(window.location.hash.substring(1));
            const queryParams = new URLSearchParams(window.location.search);

            const accessToken = hashParams.get('access_token');
            const error = hashParams.get('error') || queryParams.get('error');
            const errorDescription = hashParams.get('error_description') || queryParams.get('error_description');

            const rawState = queryParams.get('state') || hashParams.get('state');
            const tenantOrigin = rawState ? decodeURIComponent(rawState) : null;

            if (!tenantOrigin || !isAllowedTenantOrigin(tenantOrigin)) {
                this.message = 'Origine non autorisée. Fermeture...';
                setTimeout(() => window.close(), 2000);
                return;
            }

            const payload = accessToken
                ? { type: 'facebook-auth', accessToken }
                : { type: 'facebook-auth', error: errorDescription || error || 'Aucune réponse de Facebook.' };

            this.message = accessToken ? 'Connecté ! Fermeture...' : `Erreur : ${payload.error}`;

            if (window.opener) {
                window.opener.postMessage(payload, tenantOrigin);
            }

            setTimeout(() => window.close(), accessToken ? 500 : 2000);
        }
    }
};
</script>
